module.exports = __webpack_public_path__ + "static/media/communication_records_active.7d8907c8.svg";